import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { CompanyTermsTypes } from "../../../components/Models/CompanyTerms";

type UpdateTermsDto = Partial<CompanyTermsTypes>;

interface ApiResponse<T> {
  message: string;
  data: T;
}

export const useSaveCompanyTerms = (
  options?: UseMutationOptions<
    ApiResponse<CompanyTermsTypes>,
    unknown,
    CompanyTermsTypes | UpdateTermsDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<CompanyTermsTypes> | FormData) => {
      const isFormData = data instanceof FormData;

      // Determine if it's an update or create operation
      const hasId = isFormData
        ? data.get("id") ?? null
        : (data as Partial<CompanyTermsTypes>).id ?? null;

      // Set headers for FormData
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(
            getAPIURL(`/MuslimInvestProfile/CompanyTerms/Update`),
            data,
            config
          )
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(
            getAPIURL(`/MuslimInvestProfile/CompanyTerms/Create`),
            data,
            config
          )
          .then((res) => res.data);
      }
    },
  });
};
